import { get, put, post, del } from "@/utils/api";

export const BOMAPI = {
    query: async (params) => {
        return await get("/bom", params);
    },
    actives: async (params) => {
        return await get("/bom/active", params);
    },
    get: async (id) => {
        return await get(`/bom/${id}`);
    },
    add: async (params) => {
        return await put("/bom", params);
    },
    update: async (id, params) => {
        return await post(`/bom/${id}`, params);
    },
    delete: async (id) => {
        return await del(`/bom/${id}`);
    },
    activate: async (id) => {
        return await post(`/bom/${id}/activate`);
    },
    deactivate: async (id) => {
        return await post(`/bom/${id}/deactivate`);
    },
    changeStatus: async (id, status) => {
        return await post(`/bom/${id}/status`, { status });
    },
}

export const WorkOrderAPI = {
    query: async (params) => {
        return await get("/work-order", params);
    },
    actives: async (params) => {
        return await get("/work-order/active", params);
    },
    get: async (id) => {
        return await get(`/work-order/${id}`);
    },
    add: async (bomId, params) => {
        return await put(`/work-order/${bomId}`, params);
    },
    update: async (id, params) => {
        return await post(`/work-order/${id}`, params);
    },
    delete: async (id) => {
        return await del(`/work-order/${id}`);
    },
    issue: async (id) => {
        return await post(`/work-order/${id}/issue`);
    },
    unissue: async (id) => {
        return await post(`/work-order/${id}/unissue`);
    },
    shortClose: async (id) => {
        return await post(`/work-order/${id}/short-close`);
    },
    void: async (id) => {
        return await post(`/work-order/${id}/void`);
    },
}

export const WOPOAPI = {
    query: async (page, params) => {
        return await get("/wo-pick-order", { page: page, ...params });
    },
    estimate: async (woId, warehouseId) => {
        return await get(`/wo-pick-order/estimate/${woId}?warehouseId=${warehouseId}`);
    },
    get: async (id) => {
        return await get("/wo-pick-order/" + id);
    },
    getByWO: async (id) => {
        return await get("/wo-pick-order/wo/" + id);
    },
    add: async (values) => {
        return await put("/wo-pick-order", values);
    },
    update: async (wopoId, params) => {
        return await post(`/wo-pick-order/${wopoId}`, params);
    },
    voidPO: async (wopoId) => {
        return await post(`/wo-pick-order/${wopoId}/void`);
    },
}

export const WoFulfillmentAPI = {
    query: async (page, params) => get("/wo-fulfillment", { page, ...params }),
    preview: async (data) => post("/wo-fulfillment/preview", data),
    add: async (values) => put("/wo-fulfillment", values),
    get: async (id) => get("/wo-fulfillment/" + id),
    update: async (id, values) => post("/wo-fulfillment/" + id, values),
    getByWO: async (woId) => get("/wo-fulfillment/wo/" + woId),
    getByPickOrder: async (pickOrderId) => get("/wo-fulfillment/pick-order/" + pickOrderId),
    voidFulfillment: async (id) => post(`/wo-fulfillment/${id}/void`),
    checkInventoryInUse: async (id) => get(`/wo-fulfillment/${id}/inventory-in-use`),
}
